import { format } from "date-fns";
/**
 * Safely convert a value that might be a Firestore Timestamp, Date, string, or number to a Date.
 * Firestore Timestamps have { seconds, nanoseconds } shape or a toDate() method.
 */
export function toDate(value) {
    if (!value)
        return new Date();
    if (value instanceof Date)
        return value;
    if (typeof value === "string" || typeof value === "number")
        return new Date(value);
    // Firestore Timestamp with toDate() method (e.g. from onSnapshot)
    if (typeof value === "object" &&
        value !== null &&
        "toDate" in value &&
        typeof value.toDate === "function") {
        return value.toDate();
    }
    // Firestore Timestamp plain object (e.g. from JSON serialization)
    if (typeof value === "object" &&
        value !== null &&
        "seconds" in value &&
        typeof value.seconds === "number") {
        return new Date(value.seconds * 1000);
    }
    // Firestore Timestamp with _seconds (some serialization formats)
    if (typeof value === "object" &&
        value !== null &&
        "_seconds" in value &&
        typeof value._seconds === "number") {
        return new Date(value._seconds * 1000);
    }
    return new Date();
}
/**
 * Safely convert a value to a Date, returning undefined if the value is falsy.
 * Use for optional date fields (e.g. investigationStartedAt, approvedAt).
 */
export function toDateOptional(value) {
    if (!value)
        return undefined;
    return toDate(value);
}
/**
 * Safely format a date-like value using date-fns format().
 * Returns empty string if the value is invalid or missing.
 */
export function safeFormat(value, formatStr) {
    try {
        const date = toDate(value);
        if (isNaN(date.getTime()))
            return "";
        return format(date, formatStr);
    }
    catch {
        return "";
    }
}
